const { getElement, getElements } = window.BAO.Utils

export class ProductCardSwatch extends window.BAO.CustomElement() {
  connectedCallback () {
    this.desktopCheck = matchMedia('(min-width: 768px)')
    this.setupListeners()
  }

  setupListeners () {
    this.handleShowSwatchImageClick =
      this.handleShowSwatchImageClick.bind(this)

    // Flag to determine if we are in desktop mode
    this.isDesktop = this.desktopCheck.matches

    // Add initial event listeners based on screen size
    this.updateListeners()

    // Add resize event listener to switch between interactions on screen resize
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize () {
    const isNowDesktop = this.desktopCheck.matches
    if (isNowDesktop !== this.isDesktop) {
      // Only update listeners if the screen size crosses the 768px threshold
      this.isDesktop = isNowDesktop
      this.updateListeners()
    }
  }

  updateListeners () {
    // Remove any existing event listeners
    this.els.swatch.elements.forEach((swatch) => {
      swatch.removeEventListener('click', this.handleShowSwatchImageClick)

      // Add click event listeners for all screen sizes
      swatch.addEventListener('click', this.handleShowSwatchImageClick)
    })
  }

  setParentItem (e) {
    this.parentItem = e.target.closest('.prd-Card')
  }

  handleShowSwatchImageClick (e) {
    e.preventDefault() // Prevent default anchor behavior
    e.stopPropagation() // Stop event from bubbling up
    this.setParentItem(e)
    this.handleShowSwatchGallery(e)
    this.handleProductCardLink(e)
    this.handleWishlistLink(e)
    this.handleAddToCartVariant(e)
    this.handleSelectedSwatch(e)
  }

  handleShowSwatchGallery (e) {
    e.preventDefault() // Prevent default action for anchor tag
    const productId = e.target.getAttribute(
      'data-product-card-swatch-product-id',
    )

    const galleryElements = getElements(
      '[data-product-card-swatch-external-el="gallery"]',
      { context: this.parentItem },
    )

    galleryElements.forEach((gallery) => {
      const galleryId = gallery.getAttribute(
        'data-product-card-swatch-gallery-id',
      )

      if (galleryId === productId) {
        gallery.classList.add('prd-Card_Gallery-active')
      } else {
        if (this.isDesktop === false) {
          gallery.addEventListener(
            'transitionend',
            () => {
              const gallerySlides = getElement(
                '[data-product-card-gallery-slides]',
                { context: gallery },
              )

              if (gallerySlides !== null) {
                gallerySlides.dispatchEvent(new Event('reset'))
              }
            },
            { once: true },
          )
        }

        gallery.classList.remove('prd-Card_Gallery-active')
      }
    })
  }

  handleProductCardLink (e) {
    const hrefItem = e.target.getAttribute('data-product-card-swatch-url')
    const linkElements = this.parentItem.querySelectorAll(
      '[data-product-card-swatch-external-el="href"]',
    )

    linkElements.forEach((link) => {
      link.href = hrefItem
    })
  }

  handleWishlistLink (e) {
    const productUrl = e.target.getAttribute('data-product-card-swatch-url')
    const productId = e.target.getAttribute(
      'data-product-card-swatch-product-id',
    )
    const productVariantUrl = e.target.getAttribute(
      'data-product-card-swatch-variant-url',
    )
    const productVariantId = e.target.getAttribute(
      'data-product-card-swatch-variant-id',
    )
    const wishlistTrigger = this.parentItem.querySelector(
      '[data-wishlist-modal-external-el="trigger"]',
    )

    wishlistTrigger.setAttribute('data-product-url', productUrl)
    wishlistTrigger.setAttribute('data-product-id', productId)
    wishlistTrigger.setAttribute('data-variant-url', productVariantUrl)
    wishlistTrigger.setAttribute('data-variant-id', productVariantId)
  }

  handleSelectedSwatch (e) {
    const swatches = this.parentItem.querySelectorAll(
      '[data-product-card-swatch-el="swatch"]',
    )

    // Set aria-current to false for all swatches
    swatches.forEach((swatch) => swatch.setAttribute('aria-current', 'false'))

    // Set aria-current to true for the clicked swatch
    e.target.setAttribute('aria-current', 'true')
  }

  handleAddToCartVariant (e) {
    const selectedSwatchProductID = e.target.getAttribute(
      'data-product-card-swatch-product-id',
    )
    const selectedSwatchProductUrl = e.target.getAttribute(
      'data-product-card-swatch-url',
    )
    const addToCartButtons = this.parentItem.querySelectorAll(
      '[data-card-modal-external-el="trigger"]',
    )

    addToCartButtons.forEach((button) => {
      button.setAttribute('data-product', selectedSwatchProductUrl)
      button.setAttribute('data-product-id', selectedSwatchProductID)
    })
  }
}

customElements.define('product-card-swatch', ProductCardSwatch)
